import axios from "axios";

export const sendVendorOTP = async (postData) => {
  try {
    const { data } = await axios.post("/v1/send-otp", postData, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const verifyVendorOTP = async (postData) => {
  try {
    const { data } = await axios.post("/v1/verify-otp", postData, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};